import React, { useEffect, useRef } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "./UserContext";
import { submitScore } from "./lib/tournamentService";

// Cada torneo mapea el gameId al URL del juego
const gameUrls = {
  "zap-aliens": "/zap_alliens/zap-aliens-html5/game/index.html",
};

const PlayGameScreen = () => {
  const navigate = useNavigate();
  const { gameId } = useParams();
  const { user } = useUser();
  const url = gameUrls[gameId];
  const lastSubmittedScore = useRef(null);

  useEffect(() => {
    // Escucha los mensajes del iframe con el puntaje
    const handleMessage = async (event) => {
      const data = event.data;
      if (!data || typeof data !== "object") return;
      if (data.type !== "GAME_SCORE" || data.gameId !== gameId) return;

      const score = Number(data.score);
      if (!Number.isFinite(score) || score < 0) return;
      if (lastSubmittedScore.current === score) return;

      if (!user) {
        console.warn("Puntaje descartado: usuario no autenticado");
        return;
      }

      try {
        await submitScore(gameId, score, user);
        lastSubmittedScore.current = score;
        console.log(`Puntaje ${score} guardado para ${user.displayName}`);
      } catch (err) {
        console.error("Error guardando puntaje:", err);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [gameId, user]);

  if (!url) {
    return (
      <div className="w-full h-screen bg-black flex items-center justify-center text-white">
        <div className="text-center">
          <p className="text-xl mb-4">Juego no disponible</p>
          <button onClick={() => navigate("/juegos")} className="underline">
            Volver a juegos
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen bg-black flex flex-col">
      <div className="bg-blue-600 text-white p-4 flex items-center justify-between">
        <button
          onClick={() => navigate(`/torneos/${gameId}`)}
          className="hover:underline flex items-center"
        >
          <ArrowLeft className="w-5 h-5 mr-1" />
          Volver al torneo
        </button>
        <h1 className="text-lg font-semibold">Modo torneo</h1>
        {user && (
          <span className="text-sm opacity-80">Jugando como {user.displayName}</span>
        )}
      </div>

      <div className="flex-grow">
        <iframe
          src={url}
          title="Juego"
          className="w-full h-full border-none"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default PlayGameScreen;
